import { jsx as _jsx } from "react/jsx-runtime";
import './TS_PopUp.scss';
import { TS_Overlay } from '../../TS_Overlay/index.js';
import { _className, stopPropagation } from '../../../utils/tools.js';
import { resolveContent } from '@nu-art/ts-common';
import { TS_MouseInteractivity } from '../base/TS_MouseInteractivity.js';
import { mouseInteractivity_PopUp } from '../../../component-modules/mouse-interactivity/types.js';
import { ModuleFE_MouseInteractivity } from '../../../component-modules/mouse-interactivity/ModuleFE_MouseInteractivity.js';
export class TS_PopUp extends TS_MouseInteractivity {
    __onWindowResized() {
        if (this.state.model)
            ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
    }
    __onPopUpDisplay = (model) => {
        this.setState({ model, open: !!model });
    };
    render() {
        const { model, open } = this.state;
        if (!model || !open)
            return '';
        return _jsx(TS_Overlay, { className: _className('ts-popup', model.overlayClass), showOverlay: open, onClickOverlay: (e) => {
                stopPropagation(e);
                if (!model.ignoreOverlayClick || !resolveContent(model?.ignoreOverlayClick))
                    this.setState({ open: false });
                ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                model?.onOverlayClick?.(e);
            }, children: _jsx("div", { className: "ts-popup__content", id: model.id, ref: this.ref, onClick: stopPropagation, onContextMenu: stopPropagation, children: resolveContent(model.content, () => this.forceUpdate()) }) });
    }
}
//# sourceMappingURL=TS_PopUp.js.map